import React from 'react';
import PropTypes from 'prop-types';
import Close from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useTheme } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';

function AlertModal({
	open,
	onClose,
	title,
	subtitleOne,
	subtitleTwo,
	icon,
	border,
}) {
	const theme = useTheme();

	return (
		<div>
			<Modal
				open={open}
				onClose={onClose}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box
					sx={{
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						width: { xs: 'calc(100% - 1rem)', sm: 'auto' },
						minWidth: { sm: 600 },
						maxWidth: { xs: 'calc(100% - 1rem)', sm: 860 },
						bgcolor: 'background.paper',
						boxShadow: 24,
						border,
						borderRadius: theme.palette.borderRadius.Md,
						p: theme.palette.spacing.Md,
					}}
				>
					<Grid container spacing={2} p={3}>
						<Grid
							item
							xs={12}
							align="right"
							sx={{ margin: '-2.1rem -2rem auto auto' }}
						>
							<IconButton
								aria-label="clear icon button"
								aria-hidden="false"
								role="button"
								disableRipple
								onClick={onClose}
							>
								<Close
									fontSize="medium"
									role="graphics-symbol"
									aria-hidden="true"
									aria-label="clear icon"
								/>
							</IconButton>
						</Grid>
						<Grid
							item
							xs={12}
							sx={{
								marginTop: '-1.15rem',
								textAlign: 'center',
							}}
						>
							<table
								style={{
									borderCollapse: 'collapse',
									margin: '0 auto',
									width: 'auto',
									tableLayout: 'auto',
								}}
							>
								<tbody>
									<tr>
										<td
											style={{
												verticalAlign: 'middle',
												paddingRight: 12,
												width: 1,
											}}
										>
											{icon}
										</td>
										<td style={{ verticalAlign: 'middle' }}>
											<Typography
												id="modal-title"
												variant="heading2"
												noWrap
												title={title}
												sx={{
													fontWeight: theme.palette.fontWeight.bold,
													textTransform: 'capitalize',
													color: theme.palette.base.contrastText,
													overflow: 'hidden',
													textOverflow: 'ellipsis',
													display: 'block',
												}}
											>
												{title}
											</Typography>
										</td>
									</tr>
								</tbody>
							</table>

							<Typography
								id="modal-subtitle"
								sx={{
									fontSize: theme.palette.textSize.sizeMd,
									marginTop: '.5rem',
									color: theme.palette.base.contrastText,
								}}
							>
								{subtitleOne}
							</Typography>
							{!!subtitleTwo && (
								<Typography
									id="modal-subtitle"
									sx={{
										fontSize: theme.palette.textSize.sizeMd,
										marginTop: '-.15rem',
										color: theme.palette.base.contrastText,
									}}
								>
									{subtitleTwo}
								</Typography>
							)}
						</Grid>
						<Grid
							item
							xs={12}
							align="center"
							sx={{ marginTop: '.1rem', marginBottom: '.5rem' }}
						>
							<Button
								variant="outlined"
								color="primary"
								size="medium"
								role="button"
								data-testid="alert_btn_close"
								aria-label="alert_btn_close"
								onClick={onClose}
							>
								Close
							</Button>
						</Grid>
					</Grid>
				</Box>
			</Modal>
		</div>
	);
}
AlertModal.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	title: PropTypes.string.isRequired,
	subtitleOne: PropTypes.string,
	subtitleTwo: PropTypes.string,
	icon: PropTypes.node.isRequired,
	border: PropTypes.node.isRequired,
};

export default AlertModal;
